$(document).ready(function () {
  if (!$('#main_pet_select').length || !$('#pet_select').length) {
    return;
  }

  let previousMainValue = null;
  let previousOtherValue = null;

  function initSelect2() {
    $('.js-pet-select').select2({
      placeholder: "サブメインペットを選択してください。",
      allowClear: true,
      templateResult: function (state) {
        if (!state.id) return state.text;
        const imageUrl = $(state.element).data('image');
        return $(
          '<span><img src="' + imageUrl + '" style="width: 60px; height: 60px; object-fit: cover; border-radius: 10%; margin-right: 8px;"> ' +
          state.text + '</span>'
        );
      },
      templateSelection: function (state) {
        if (!state.id) return state.text;
        const imageUrl = $(state.element).data('image');
        return $(
          '<span><img src="' + imageUrl + '" style="width: 60px; height: 60px; object-fit: cover; border-radius: 10%; margin-right: 6px;"> ' +
          state.text + '</span>'
        );
      }
    });
  }

  function cacheOriginalOptions($select) {
    if (!$select.data('original-options')) {
      $select.data('original-options', $select.find('option').clone());
    }
  }

  function updateSelectOptions(changedSelect = null) {
    const $main = $('#main_pet_select');
    const $other = $('#pet_select');

    const mainSelected = $main.val();
    const otherSelected = $other.val();

    cacheOriginalOptions($main);
    cacheOriginalOptions($other);

    $main.empty();
    $main.data('original-options').each(function () {
      $main.append($(this).clone());
    });

    $other.empty();
    $other.data('original-options').each(function () {
      $other.append($(this).clone());
    });

    if (changedSelect === 'main') {
      $main.val(mainSelected);
      
      if (mainSelected && otherSelected && mainSelected === otherSelected) {
        if (previousMainValue && previousMainValue !== mainSelected) {
          $other.val(previousMainValue);
        } else {
          const availableOptions = $other.data('original-options').filter(function() {
            return $(this).val() !== '' && $(this).val() !== mainSelected;
          });
          
          if (availableOptions.length > 0) {
            const newValue = $(availableOptions[0]).val();
            $other.val(newValue);
          } else {
            $other.val('');
          }
        }
      } else {
        $other.val(otherSelected);
      }
    } else if (changedSelect === 'other') {
      $other.val(otherSelected);
      
      if (mainSelected && otherSelected && mainSelected === otherSelected) {
        if (previousOtherValue && previousOtherValue !== otherSelected) {
          $main.val(previousOtherValue);
        } else {
          const availableOptions = $main.data('original-options').filter(function() {
            return $(this).val() !== '' && $(this).val() !== otherSelected;
          });
          
          if (availableOptions.length > 0) {
            const newValue = $(availableOptions[0]).val();
            $main.val(newValue);
          } else {
            $main.val('');
          }
        }
      } else {
        $main.val(mainSelected);
      }
    } else {
      $main.val(mainSelected);
      $other.val(otherSelected);
    }

    updateAriaSelected($main);
    updateAriaSelected($other);

    $main.trigger('change.select2');
    $other.trigger('change.select2');
  }

  function updateAriaSelected($select) {
    const selectedValue = $select.val();
    
    $select.find('option').each(function() {
      const $option = $(this);
      const optionValue = $option.val();
      
      if (optionValue === selectedValue) {
        $option.attr('aria-selected', 'true');
      } else {
        $option.attr('aria-selected', 'false');
      }
    });
    
    setTimeout(() => {
      const selectId = $select.attr('id');
      
      $(`.select2-results__option`).each(function() {
        const $li = $(this);
        const $resultsContainer = $li.closest('.select2-results__options');
        
        if ($resultsContainer.length > 0) {
          const containerId = $resultsContainer.attr('data-select2-id');
          if (containerId && containerId.includes(selectId)) {
            const optionText = $li.text().trim();
            const $matchingOption = $select.find('option').filter(function() {
              return $(this).text().trim() === optionText;
            });
            
            if ($matchingOption.length > 0) {
              const optionValue = $matchingOption.val();
              if (optionValue === selectedValue) {
                $li.attr('aria-selected', 'true');
                $li.addClass('select2-results__option--selected');
              } else {
                $li.attr('aria-selected', 'false');
                $li.removeClass('select2-results__option--selected');
              }
            }
          }
        }
      });
    }, 100);
  }

  let isUpdating = false;

  $('#main_pet_select').on('change', function () {
    if (!isUpdating) {
      isUpdating = true;
      const currentValue = $(this).val();
      setTimeout(() => {
        updateSelectOptions('main');
        previousMainValue = currentValue;
        isUpdating = false;
      }, 10);
    }
  });

  $('#pet_select').on('change', function () {
    if (!isUpdating) {
      isUpdating = true;
      const currentValue = $(this).val();
      setTimeout(() => {
        updateSelectOptions('other');
        previousOtherValue = currentValue;
        isUpdating = false;
      }, 10);
    }
  });

  initSelect2();
  previousMainValue = $('#main_pet_select').val();
  previousOtherValue = $('#pet_select').val();
  updateSelectOptions();
});
